import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/animated-tabs'
import MyTasks from './(tabs)/my-tasks'
import AllTasks from './(tabs)/all-tasks'
import { Button } from '@/components/ui/button'
import * as Icons from 'lucide-react'
import CreateTask from '@/components/features/tasks/create'
import { useQueryClient } from '@tanstack/react-query'
import { useAuth } from '@/hooks/use-auth'
import { hasRight } from '@/config/rights.config'
import TasksDashboard from './(tabs)/tasks-dashboard'

const TasksPage = () => {
  const { user } = useAuth()
  const queryClient = useQueryClient();

  return (
    <div className='p-4 space-y-4 h-full flex flex-col justify-between overflow-auto'>
      <header>
        <h1 className='text-3xl font-bold'>Taken</h1>
      </header>

      <Tabs className="h-full overflow-auto" defaultValue='my-tasks'>
        <div className='flex flex-col justify-between h-full'>
            <div className='flex items-center justify-between gap-4'>
                <TabsList>
                  {hasRight(user?.role?.name, "TASKS.WRITE") && <TabsTrigger value='dashboard'>Overzicht</TabsTrigger>}
                  <TabsTrigger value='my-tasks'>Mijn taken</TabsTrigger>
                  {hasRight(user?.role?.name, "TASKS.WRITE") && <TabsTrigger value='all-tasks'>Alle taken</TabsTrigger>}
                </TabsList>

                {hasRight(user?.role?.name, "TASKS.WRITE") && 
                <CreateTask 
                  onCreated={() => { 
                    queryClient.invalidateQueries({ queryKey: ['tasks'] });
                  }}
                  trigger={
                    <Button variant='bright'>
                        <Icons.Plus className="w-4 h-4"/>
                        Nieuwe taak
                    </Button>
                  }
                />
                }
            </div>

            <TabsContent value='dashboard' className='overflow-auto h-full'>
              <TasksDashboard />
            </TabsContent>

            <TabsContent value='my-tasks' className='overflow-auto h-full'>
              <MyTasks />
            </TabsContent>

            <TabsContent value='all-tasks' className='overflow-auto h-full'>
              <AllTasks />
            </TabsContent>
        </div>
      </Tabs>
    </div>
  )
}

export default TasksPage